import type { FunctionComponent } from 'react';

import IconContract from 'assets/images/icon-fullscreen-contract.svg';
import IconExpand from 'assets/images/icon-fullscreen-expand.svg';

import S from './style.scss';

type PropsT = {
  active: boolean;
  onToggle: () => void;
};

const FullscreenButton: FunctionComponent<PropsT> = ({ active, onToggle }) => (
  <button
    aria-label="Toggle fullscreen"
    className={S.button}
    onClick={onToggle}
    type="button"
  >
    {active
      ? <IconContract className={S.icon} />
      : <IconExpand className={S.icon} />}
  </button>
);

export default FullscreenButton;
